import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ModernSlaveryPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    MODERN SLAVERY STATEMENT AND POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Commitment to Preventing Modern Slavery and Human Trafficking
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Laurence T. Sofowora</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V6 – 2026</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>31/03/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>31/03/2026</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>March 2027</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>ALL EMPLOYEES and FREELANCE STAFF</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Introduction */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Introduction
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This policy statement sets out the principles and priorities that govern D.T.K. Business Services Limited (DTK), in response to protecting vulnerable individuals from Modern Slavery and Trafficking within our own organisation or those with whom we interface as part of supply chain activity. DTK is for the purposes of this legislation deemed to be a SME business.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This document is intended to provide guidance to our staff, agencies, and stakeholders (including employers) to understand all potential risks related to DTK business and to ensure steps are maintained to prevent slavery and human trafficking. These guidelines will form part of staff induction and are applicable to all DTK business areas. It is owned by the DTK executive team for implementation by all staff. As well as outlining DTK duty to comply, these guidelines seek to educate everyone on identifying risks and subsequently reporting them.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK has a zero-tolerance approach to modern slavery and human trafficking and are fully committed to preventing slavery and human trafficking, ensuring there is transparency within DTK and supply chains.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    As part of our initiative to identify and mitigate risk (including in relation to that of human trafficking and slavery) we operate a range of policies which serve to address the requirements of the Modern Slavery Act 2015.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    This statement governs our responsibilities within the organisation and ensures that all partners, subcontractors, and suppliers will promote these guidelines in line with our statement and legal requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Policies */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Our Policies
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Our policies reflect our commitment to acting ethically and with integrity in all our business relationships and to implementing and enforcing effective due diligence and contractual compliance. These include:
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Due Diligence Policy */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Our Due Diligence Policy
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK conducts due diligence on all potential partners and suppliers before entering into business relationships. Our due diligence policy reflects the fact that many of our operating environments (Skills and Employment) are high risk for modern slavery and human trafficking. All information gathered from our due diligence is updated annually and recorded in our internal risk register. We are also committed to carrying out spot-checks and 'deep dives' to gather further information about a supplier and their practices. Additionally, we check Government websites to ensure that we do not inadvertently fund organisations registered as supporting slavery, trafficking, or radicalisation.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    As part of the due diligence process DTK promotes our own policy in these areas and encourages all suppliers to have a Modern Slavery Policy or Guideline within their business as well as a Code of Conduct, which will be presented to DTK contracting/purchasing team prior to any funding relationship. We are also committed to capacity building across our supply chains and working with suppliers to develop modern slavery policies where none exist and/or to strengthen policies as required. We do not engage with businesses that do not share our commitment to eradicating slavery/ radicalisation/trafficking.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The following modern slavery and human trafficking questions are asked of all organisations:
                  </p>

                  <ol style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '20px' }}>
                    <li style={{ marginBottom: '15px' }}>Does the organisation have a statement / policy on modern slavery and human trafficking?</li>
                    <li style={{ marginBottom: '15px' }}>Please supply the following –
                      <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                        <li>Details of any training undertaken for all staff</li>
                        <li>Details of procedures for dealing with cases</li>
                        <li>Details of practices/process of implementing the above if none exist.</li>
                      </ul>
                    </li>
                    <li style={{ marginBottom: '15px' }}>How does the organisation flow down its statement/policy to all staff and the supply chain and what checks are undertaken to ensure implementation?</li>
                    <li style={{ marginBottom: '15px' }}>What is the organisation's website address for details of the Modern Slavery Statement?</li>
                    <li style={{ marginBottom: '15px' }}>Have any of the organisation's employees being investigated under the Modern Slavery Act 2015?
                      <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                        <li>Please provide accurate details including any convictions</li>
                      </ul>
                    </li>
                    <li style={{ marginBottom: '15px' }}>Has the organisation dealt with any incidents related to modern slavery or human trafficking in the past?
                      <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                        <li>If yes, please provide accurate details with follow-up actions.</li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Code of Conduct */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Code of Conduct
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Our code of Conduct makes clear to employees the actions and behaviour expected of them when representing the organisation. We strive to maintain the highest standards of employee conduct and ethical behaviour when operating and managing our supply chain.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Whistle blowing Policy */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Whistle blowing Policy
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    DTK embeds our modern slavery/trafficking stance at induction and encourages all its workers, service users, customers, and business partners to report any concerns related to the direct activities, or the supply chains of, the organisation. This includes any circumstances that may give rise to an enhanced risk of slavery or human trafficking. The organisation's whistleblowing procedure is designed to make it easy for workers to make disclosures, without fear of retaliation. Employees, service users, customers or others who have concerns can use our confidential escalation process as detailed in the policy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Recruitment Policy */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Recruitment Policy
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    DTK will only work with organisations that are fully approved and use 'safer recruitment' practices.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Safeguarding Policy */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Safeguarding Policy
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Our Safeguarding (including Prevent) policy sets out the legislative requirements to provide a duty of care, promote positive well-being and provide a clear process for escalating concerns to protect the welfare of individuals. This is available on the DTK website or by request in hard copy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Equality, Diversity, and Inclusion Policy */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Equality, Diversity, and Inclusion Policy
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Our Equality, Diversity and Inclusion policy is in place to ensure that we treat people fairly and with respect. DTK is committed to being an organisation representative of the communities that we deliver services to and strive to create and implement our Equality, Diversity, and Inclusion strategy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our supply chains and supplier adherence to our values */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Our supply chains and supplier adherence to our values
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    We expect the highest standards of conduct and probity throughout our supply chain, requiring all our people to act with integrity and honesty. Our procurement processes include standard enquiries about modern slavery and trafficking, and we examine our supply chain using our dedicated quality assurance functions including audit, supply chain management, legal and risk.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    DTK will continue to work with suppliers to ensure that they meet these standards and comply with the requirements of The Modern Slavery Act 2015.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What we will do */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    What we will do
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    As part of our commitment to eradicating modern slavery and human trafficking we will:
                  </p>

                  <ol style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '0' }}>
                    <li style={{ marginBottom: '15px' }}>Introduce online training in the Modern Slavery Act which will be made compulsory at induction for all staff who will have a requirement to complete mandatory training on the act, including how to identify and escalate any concerns.</li>
                    <li style={{ marginBottom: '15px' }}>Continue to review and develop the policies, processes, and controls in place to support our commitment to mitigate risks of modern slavery across our organisation in line with best practice and legislation changes.</li>
                    <li style={{ marginBottom: '0' }}>DTK will review and update this statement to meet the requirements of the Modern Slavery Act on an annual basis.</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Approval */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Approval
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    This statement is made pursuant to section 54(1) of the Modern Slavery Act 2015, is approved by Rev 'Kunle Ayeni, Managing Director and constitutes our slavery and human trafficking statement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default ModernSlaveryPolicy;
